{
	"title": "Transaction",
	"timestamp": "Timestamp",
	"productDescription": "evoZero product name",
	"invoiceNumber": "Invoice number / line item number",
	"greyMaterial": "Grey material",
	"customer": "Customer",
	"epdId": "EPD ID",
	"plant": "Plant",
	"quantity": "Quantity",
	"productGwpEmissions": "Product GWP emissions",
	"allocatedCarbonReductionsFossil": "Allocated carbon reductions – Fossil",
	"adjustment": "Adjustment",
	"correctionFossil": "Correction Fossil",
	"allocatedCarbonReductionsBiogenic": "Allocated carbon reductions – Biogenic",
	"correctionBiogenic": "Correction Biogenic",
	"eacEquivalent": "EAC equivalent",
	"fetchError": "Failed to load transaction details"
}
